/* ── No Label Coffee — theme.js ────────────────────── */

/* ── Scroll reveal ────────────────────────────────── */
(function () {
  const observer = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add('visible');
        observer.unobserve(e.target);
      }
    });
  }, { threshold: 0.1 });
  document.querySelectorAll('.reveal').forEach(el => observer.observe(el));
})();

/* ── Header scroll state ─────────────────────────── */
(function () {
  const header = document.getElementById('site-header');
  if (!header) return;
  window.addEventListener('scroll', () => {
    header.classList.toggle('scrolled', window.scrollY > 60);
  }, { passive: true });
})();

/* ── Smooth anchor scroll ────────────────────────── */
document.querySelectorAll('a[href^="#"]').forEach(a => {
  a.addEventListener('click', e => {
    const id = a.getAttribute('href');
    const target = document.querySelector(id);
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
});

/* ── Toast notification ──────────────────────────── */
function showToast(msg) {
  let toast = document.getElementById('nlc-toast');
  if (!toast) {
    toast = document.createElement('div');
    toast.id = 'nlc-toast';
    toast.className = 'toast';
    document.body.appendChild(toast);
  }
  toast.textContent = msg;
  toast.classList.add('show');
  clearTimeout(toast._timer);
  toast._timer = setTimeout(() => toast.classList.remove('show'), 2800);
}

/* ── Cart state ───────────────────────────────────── */
const Cart = {
  async get() {
    const res = await fetch('/cart.js');
    return res.json();
  },

  async add(variantId, qty = 1) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty })
    });
    if (!res.ok) {
      const err = await res.json();
      throw new Error(err.description || 'Could not add to cart');
    }
    return res.json();
  },

  async change(key, qty) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    });
    return res.json();
  },

  async remove(key) {
    return Cart.change(key, 0);
  },

  formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }
};

/* ── Cart drawer ──────────────────────────────────── */
const CartDrawer = {
  drawer: null,
  overlay: null,

  init() {
    this.drawer  = document.getElementById('cart-drawer');
    this.overlay = document.getElementById('cart-overlay');
    if (!this.drawer) return;

    document.getElementById('cart-close-btn')?.addEventListener('click', () => this.close());
    this.overlay.addEventListener('click', () => this.close());
    document.querySelector('.cart-continue')?.addEventListener('click', () => this.close());

    document.querySelectorAll('[data-cart-open]').forEach(btn => {
      btn.addEventListener('click', () => this.open());
    });
  },

  async open() {
    await this.render();
    this.drawer.classList.add('open');
    this.overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  },

  close() {
    this.drawer.classList.remove('open');
    this.overlay.classList.remove('open');
    document.body.style.overflow = '';
  },

  async render() {
    const cart = await Cart.get();
    const itemsEl = document.getElementById('cart-drawer-items');
    const subtotalEl = document.getElementById('cart-subtotal-price');

    if (subtotalEl) subtotalEl.textContent = Cart.formatMoney(cart.total_price);
    this.updateCount(cart.item_count);

    if (!itemsEl) return;

    if (cart.item_count === 0) {
      itemsEl.innerHTML = '<p class="cart-empty-msg">Your cart is empty.</p>';
      return;
    }

    itemsEl.innerHTML = cart.items.map(item => `
      <div class="cart-item" data-key="${item.key}">
        <img class="cart-item-image" src="${item.image || ''}" alt="${item.title}" loading="lazy">
        <div>
          <p class="cart-item-title">${item.product_title}</p>
          <p class="cart-item-variant">${item.variant_title !== 'Default Title' ? item.variant_title : ''}</p>
          <div class="cart-item-qty">
            <button class="qty-btn" data-action="dec" data-key="${item.key}" data-qty="${item.quantity}">−</button>
            <span class="qty-val">${item.quantity}</span>
            <button class="qty-btn" data-action="inc" data-key="${item.key}" data-qty="${item.quantity}">+</button>
          </div>
        </div>
        <div style="display:flex;flex-direction:column;align-items:flex-end;gap:8px;">
          <span class="cart-item-price">${Cart.formatMoney(item.final_line_price)}</span>
          <button class="cart-remove" data-key="${item.key}" aria-label="Remove">×</button>
        </div>
      </div>
    `).join('');

    itemsEl.querySelectorAll('.qty-btn').forEach(btn => {
      btn.addEventListener('click', async () => {
        const key = btn.dataset.key;
        const qty = parseInt(btn.dataset.qty);
        const newQty = btn.dataset.action === 'inc' ? qty + 1 : Math.max(0, qty - 1);
        await Cart.change(key, newQty);
        await this.render();
      });
    });

    itemsEl.querySelectorAll('.cart-remove').forEach(btn => {
      btn.addEventListener('click', async () => {
        await Cart.remove(btn.dataset.key);
        await this.render();
      });
    });
  },

  updateCount(count) {
    document.querySelectorAll('.cart-count').forEach(el => {
      el.textContent = count;
      el.dataset.count = count;
    });
  }
};

/* ── Add to cart buttons (collection / home pages) ── */
document.querySelectorAll('.product-atc-btn[data-variant-id]').forEach(btn => {
  btn.addEventListener('click', async () => {
    const variantId = btn.dataset.variantId;
    if (!variantId) return;
    const original = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    try {
      await Cart.add(variantId);
      btn.textContent = 'Added ✓';
      await CartDrawer.render();
      setTimeout(() => CartDrawer.open(), 300);
    } catch (e) {
      showToast(e.message);
      btn.textContent = original;
    } finally {
      setTimeout(() => {
        btn.textContent = original;
        btn.disabled = false;
      }, 1800);
    }
  });
});

/* ── Product page add to cart ────────────────────────── */
const productForm = document.getElementById('product-form');
if (productForm) {
  productForm.addEventListener('submit', async e => {
    e.preventDefault();
    const btn = productForm.querySelector('.product-page-atc');
    const variantSelect = productForm.querySelector('[name="id"]');
    const variantId = variantSelect ? variantSelect.value : productForm.dataset.variantId;
    if (!variantId) return;
    const original = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    try {
      await Cart.add(variantId);
      btn.textContent = 'Added ✓';
      await CartDrawer.render();
      setTimeout(() => CartDrawer.open(), 300);
    } catch (e) {
      showToast(e.message);
    } finally {
      setTimeout(() => {
        btn.textContent = original;
        btn.disabled = false;
      }, 1800);
    }
  });
}

/* ── Cart page qty / remove ───────────────────────────── */
document.querySelectorAll('.cart-page-qty-btn').forEach(btn => {
  btn.addEventListener('click', async () => {
    const key = btn.dataset.key;
    const qty = parseInt(btn.dataset.qty);
    const newQty = btn.dataset.action === 'inc' ? qty + 1 : Math.max(0, qty - 1);
    await Cart.change(key, newQty);
    window.location.reload();
  });
});

document.querySelectorAll('.cart-page-remove').forEach(btn => {
  btn.addEventListener('click', async () => {
    await Cart.remove(btn.dataset.key);
    window.location.reload();
  });
});

/* ── Init on load ────────────────────────────────────── */
document.addEventListener('DOMContentLoaded', () => {
  CartDrawer.init();
  Cart.get().then(cart => CartDrawer.updateCount(cart.item_count));
});
